import React from 'react';
import {
    Create, SimpleForm, TextInput, TextField, Show, SimpleShowLayout,
    List, Datagrid, NumberInput, DateInput, NumberField, DateField, ShowButton
} from 'admin-on-rest';
import PackageTemplatesSelect from "./components/packageTemplatesSelect";
import {requireValidation, requiredAndNumberMinValidation} from "./utils/validation";
import CouponUsersInput from './components/CouponUsersInput'
import SelectArrayField from './components/SelectArrayField'
import CouponUsersField from './components/CouponUsersField'


export const CouponList = (props) => (
    <List {...props} sort={{field: '_id', order: 'DESC'}} perPage={40}>
        <Datagrid bodyOptions={{stripedRows: true, showRowHover: true}}>
            <TextField label="Name" source="name"/>
            <DateField label="Expiration date" source="expiredAt" locales="fr-CA" options={{month:'2-digit',day:'2-digit', year:'numeric', timeZone: 'UTC'}} />
            <NumberField label="Discount, %" source="discount" />
            <ShowButton />
        </Datagrid>
    </List>
)

const tzOffset = new Date().getTimezoneOffset() / 60
const dateParser = v => {
    const regexp = /(\d{4})-(\d{2})-(\d{2})/
    let match = regexp.exec(v)
    if (match === null) return

    let year = match[1]
    let month = match[2]
    let day = match[3]

    if (tzOffset < 0) {
        const date = new Date(v)
        date.setDate(date.getDate() + 1);
        match = regexp.exec(date.toISOString())
        if (!match) return null
        year = match[1]
        month = match[2]
        day = match[3]
    }
    const date = [year, month, day].join('-')
    return date + 'T00:00:00Z'
}

export const CouponCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput label="Name" source="name" validate={requireValidation}/>
            <DateInput parse={dateParser} validate={requireValidation} label="Expiration date" source="expiredAt" options={{
                mode: 'landscape',
                minDate: new Date(),
                hintText: 'Select date',
                okLabel: 'OK',
                cancelLabel: 'Cancel',
            }}/>
            <PackageTemplatesSelect validate={requireValidation} label="Package identifiers"
                                    source="productIdentifiers" {...props} />
            <NumberInput label="Discount, %" source="discount" validate={requiredAndNumberMinValidation}/>
            <CouponUsersInput source="shortUserIds" validate={requireValidation} {...props} />
        </SimpleForm>
    </Create>);

export const CouponShow = (props) => (<Show {...props}>
    <SimpleShowLayout>
        <TextField label="Name" source="name"/>
        <DateField label="Expiration date" source="expiredAt" locales="fr-CA" options={{month:'2-digit',day:'2-digit', year:'numeric', timeZone: 'UTC'}} />
        <TextField label="Discount, %" source="discount" />
        <SelectArrayField label="Package identifiers" source="productIdentifiers" />
        <CouponUsersField label="User id" source="shortUserIds" />
    </SimpleShowLayout>
</Show>);


// WEBPACK FOOTER //
// ./src/coupons.js